<!-- Modal Header -->
<div class="modal-header" #modalHeader tabindex="-1">
  <h3 class="modal-title"><strong>{{title}}</strong></h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="row">
    <!-- Key Information -->
    <div class="col-md-12">
      <div class="main-hdr-bg">
        <b>Key:</b>&nbsp;
        <div style="display: inline-block; margin-left: 5px;">LEID - CDR - RPT.PD - BSLA - CUR</div>
      </div>

      <!-- Entities Display (when <= 10 entities) -->
      @if (entities.length < 10 && entities.length > 0) {
<div class="entitie-holder">
        @for (entity of entities; track $index; let i = $index) {
<div class="btn-group dropup pull-left" 
            
             ap-tooltip [tooltipContent]="entity.data?.SCHDM_DESC || ''" [direction]="'top'" [appendAfterTarget]="true">
          <button type="button" class="btn btn-xs btn-default">
            {{ entity.data?.LEID }} - {{ entity.data?.CDR_NO }} - {{ entity.data?.REPORTING_PERIOD }} - {{ entity.data?.ME_CODE }} - {{ entity.data?.CURR }}
          </button>
          <button type="button" 
                  (click)="removeEntity(i)" 
                  class="btn btn-xs btn-danger dropdown-toggle" 
                  ap-tooltip [tooltipContent]="'Remove entity'" [direction]="'top'" [appendAfterTarget]="true"
                  data-toggle="dropdown" 
                  aria-haspopup="true" 
                  aria-expanded="false">
            <span class="fa fa-times"></span>
          </button>
        </div>
}
      </div>
}

      <!-- Entities Display (when > 10 entities) -->
      @if (entities.length >= 10) {
<div class="entitie-holder">
        <div>
          <label>
            Selected Entities Count: 
            <span class="badge badge-pill badge-info">{{entities.length}}</span>
          </label>
        </div>
      </div>
}

      <!-- Upload/Delete Attachments Panel -->
      @if (showUploadDeletePanel) {
<div class="panel panel-default">
        <div class="panel-heading">
          <label for="notify">Upload/Delete Attachments:</label>
        </div>

        <div class="panel-body">
          <!-- Error Message -->
          @if (attachmentTO.isError) {
<span 
                class="form-error-container" 
                style="background-color:orange; margin-bottom: 15px; display: block; padding: 10px;">
            Upload failed:
            <b style="color:green">
              Allowed Extensions: "jpg", "jpeg", "png", "svg", "pdf", "xls", "xlsx", "txt", "doc", "docx", "ico", "ppt", "pptx", "ods", "wpd", "rtf"
            </b>
          </span>
}

          <div style="display: flex;">
            <!-- Upload Button -->
            <div class="well well-xs pull-left" style="margin-right: 5px;">
              <div class="btn btn-default btn-xs btn-white"
                   ap-tooltip [tooltipContent]="'Attach document'" [direction]="'bottom'" [appendAfterTarget]="true"
                   (click)="triggerFileInput()"
                   style="cursor: pointer; margin: 5px;">
                <i class="fa fa-paperclip"></i>
              </div>
              <input type="file" 
                     #fileInput 
                     (change)="onFileSelected($event)" 
                     multiple 
                     style="display: none;"
                     accept=".jpg,.jpeg,.png,.svg,.pdf,.xls,.xlsx,.txt,.doc,.docx,.ico,.ppt,.pptx,.ods,.wpd,.rtf">
            </div>

            <!-- Attached Files Display -->
            <div style="width: 100%;" class="well well-xs pull-left">
              @for (file of attachmentTO.attachmented_files; track $index; let i = $index) {
<div class="btn-group btn-group-xs" 
                   role="group" 
                   
                   style="margin: 5px;">
                <div class="btn btn-xs btn-default">
                  <i class="fa fa-paperclip"></i>
                </div>
                <div class="btn btn-default btn-xs btn-white">
                  {{extractFileName(file)}}
                </div>
                <div class="btn btn-danger btn-xs" 
                     ap-tooltip [tooltipContent]="'Remove attachment'" [direction]="'right'" [appendAfterTarget]="true"
                     (click)="revmoveFile(file, i)"
                     style="cursor: pointer;">
                  <i class="fa fa-times"></i>
                </div>
              </div>
}
            </div>
          </div>

          <!-- Upload Progress -->
          @for (file of uploadingFiles; track $index) {
<div>
            @if (file.progress < 100) {
<div>
              Uploading {{file.name}}
              <div class="progress" style="margin-top: 5px;">
                <div class="progress-bar progress-bar-info progress-bar-striped active" 
                     role="progressbar"
                     [style.width.%]="file.progress">
                  {{file.progress}}%
                </div>
              </div>
            </div>
}
          </div>
}
        </div>
      </div>
}
    </div>

    <!-- Existing Attachments Panel -->
    <div class="col-md-12">
      @if ((attachmentList$ | async)?.length) {
<div class="panel panel-default attachemnts-block">
        <div class="panel-heading" 
             (click)="attachmentsMinimise = !attachmentsMinimise" 
             style="cursor: pointer;">
          <b>Attachments:</b>
          <i class="fa fa-chevron-right expand-icn" 
             [ngClass]="{'rotate-arrow-icn': !attachmentsMinimise}">
          </i>
        </div>
        
        <div class="panel-body panel-body-collapsible" [@collapseAnimation]="attachmentsMinimise ? 'collapsed' : 'expanded'">
          @for (file of attachmentList$ | async; track $index) {
<div class="attachment-files col-md-3">
            <div class="attachment-files-labels">
              <b>File Name:</b> {{file.file_name}}<br>
              <b style="margin-right: 5px;">Batch Id:</b>{{file.doc_batch_id}}<br>
              <b style="margin-right: 5px;">Type:</b>{{file.file_type}}<br>
              <b style="margin-right: 5px;">Size:</b>{{file.fS}}<br>
              <b style="margin-right: 5px;">Uploaded By:</b>{{file.updated_by}}<br>
              <b style="margin-right: 5px;">Uploaded On:</b>{{file.created_on}}<br>
              <i class="fa fa-cloud-download" 
                 style="font-size: 15px; cursor: pointer;"
                 (click)="downloadAttachmentFile(file.file_name, file.parent_key, file.attachment_key)"
                 ap-tooltip [tooltipContent]="'Download'" [direction]="'top'" [appendAfterTarget]="true">
              </i>
            </div>
          </div>
}
        </div>

        @if (enableEditAttachBtn) {
<div class="panel-footer" [@collapseAnimation]="attachmentsMinimise ? 'collapsed' : 'expanded'">
          <button class="btn btn-info btn-sm" 
                  (click)="showUploadPanel()" 
                  [disabled]="btnDisabled">
            Edit/Add Attachments
          </button>
        </div>
}
      </div>
}
    </div>

    <!-- Comments Section -->
    <div class="col-md-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          <b>Comments:</b>
        </div>
        
        <div class="panel-body">
          <!-- Loading Spinner -->
          @if (loadingComments) {
<div class="msg-loading reply-msg-loading text-center">
            <i style="margin-top: 100px;" class="fa fa-spinner fa-pulse fa-4x fa-fw"></i>
            <span class="sr-only">Loading...</span>
          </div>
}

          <!-- No Comments Message -->
          <!-- <div class="text-center" *ngIf="docComments.length <= 0 && !loadingComments">
            <h4>No Comments to Display...</h4>
          </div> -->

          <!-- Comments List -->
          @for (rM of docComments; track $index; let i = $index) {
<div class="col-md-12 msg-rply">
            <div class="col-md-1 text-center" style="width: 70px; padding-left: 0;">
              <div class="user-avatar" 
                   [attr.data-name]="rM.display_name" 
                   style="width: 45px; height: 45px; border-radius: 50%; background-color: #dfdfdf; display: flex; align-items: center; justify-content: center; font-weight: bold; color: #333;">
                {{rM.display_name?.charAt(0) || 'U'}}
              </div>
            </div>
            <div class="col-md-11 msg-rply-leftbox">
              <div class="msg-rply-hdr">
                <span style="font-size: 15px;">{{rM.display_name}}</span>
                <span style="float: right;">{{timeago(rM.date)}}</span>
              </div>
              <div class="col-md-11" style="padding: 5px 15px;">
                <!-- Display Message -->
                @if (!rM.isUpdate) {
<div>
                  {{rM.message}}
                </div>
}
                <!-- Edit Message -->
                @if (rM.isUpdate) {
<textarea
                          cols="35" 
                          rows="3" 
                          [(ngModel)]="rM.replyMessage"
                          class="form-control" 
                          style="height: 42px; margin: 5px 0;">
                </textarea>
}
              </div>
              <div class="col-md-1" style="text-align: right;">
                <!-- Menu Icon -->
                @if (!rM.isUpdate) {
<i 
                   class="fa fa-ellipsis-v" 
                   (click)="showReplySubMenu(rM)" 
                   ap-tooltip [tooltipContent]="'Options'" [direction]="'left'" [appendAfterTarget]="true"
                   style="padding: 0 10px; cursor: pointer;">
                </i>
}
                
                <!-- Dropdown Menu -->
                <div class="gg-drop-down" style="z-index: 9999; position: relative;">
                  <div class="edit-btn gg-toggle-menu">
                    <ul class="gg-drop-down-menu" 
                        [ngClass]="{'open': rM.isShowReplySubMenu}"
                        style="left: calc(100% - 90px); top: -15px;">
                      <li class="gg-message-action" (click)="startEditComment(rM)">Edit</li>
                      <li class="gg-message-action" (click)="updateDocMessage(rM, 'delete', i)">Delete</li>
                    </ul>
                  </div>
                </div>
                
                <!-- Edit Actions -->
                @if (rM.isUpdate) {
<span>
                  <i class="fa fa-share-square-o send-icn" 
                     (click)="updateDocMessage(rM, 'update', i)"
                     ap-tooltip [tooltipContent]="'Save'" [direction]="'top'" [appendAfterTarget]="true"
                     style="cursor: pointer;">
                  </i>
                </span>
}
                @if (rM.isUpdate) {
<span>
                  <i class="fa fa-times del-icn" 
                     (click)="cancelEditComment(rM)"
                     ap-tooltip [tooltipContent]="'Cancel'" [direction]="'top'" [appendAfterTarget]="true"
                     style="cursor: pointer;">
                  </i>
                </span>
}
              </div>
            </div>
          </div>
}
        </div>

        <!-- Comment Input -->
        <div class="panel-footer">
          <textarea placeholder="type a message" 
                    rows="3" 
                    (keyup)="addDocComment($event)" 
                    [(ngModel)]="replyMessage" 
                    class="form-control" 
                    style="height: 50px; padding: 10px;">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" style="margin: 0;" [hidden]="minimise">
  <button class="btn btn-info btn-sm" 
          type="button" 
          (click)="saveAttachment()" 
          [disabled]="btnDisabled">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
} Save
  </button>
  <button class="btn btn-warning btn-sm" 
          type="button" 
          (click)="cancel()" 
          [disabled]="btnDisabled">
    Cancel
  </button>
</div>

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onRemoveConfirm()"
    (cancelled)="onRemoveCancel()"
    (closed)="onRemoveCancel()">
  </gtw-confirmation-modal>
</div>
}
